import { useEffect, useMemo } from 'react';

import { environment } from 'environments';

import { useAppSelector } from './use-app-selector';
import { getUser } from '../store';

export enum Entity {
  A1QA = 'A1QA',
  Itransition = 'Itransition',
}

export enum Environment {
  production = 'production',
  stage = 'stage',
}

export const useCommonUIElements = () => {
  const url = window.location.href;
  const user = useAppSelector(getUser);

  const currentPortalName = 'Benefits';

  const entityName = useMemo(() => (user?.email.includes('a1qa') ? Entity.A1QA : Entity.Itransition), [user]);

  const env = useMemo(
    () => (url.includes('stage') || url.includes('localhost') ? Environment.stage : Environment.production),
    [url],
  );

  useEffect(() => {
    const script = document.createElement('script');

    script.src = environment.commonUIElementsUrl;
    script.type = 'module';

    document.body.appendChild(script);
  }, []);

  return { entityName, environment: env, currentPortalName };
};
